<template>
  <div
    class="relative inline-block"
    v-on-clickaway="close">
    <div
      class="whitespace-no-wrap cursor-pointer"
      @click.prevent="toggle">
      <slot>
        <XButton outline>
          {{ title }}
          <XIcon
            name="fa/solid/caret-down"
            class="ml-2" />
        </XButton>
      </slot>
    </div>
    <div
      :class="menuClasses"
      :style="menuStyles"
      class="absolute min-w-40 py-2 mt-1 text-base text-left list-reset">
      <div
        v-if="$slots.header"
        class="flex justify-end whitespace-no-wrap">
        <slot name="header" />
      </div>

      <template v-if="$slots.items || data.length">
        <slot name="items" />
      </template>
    </div>
  </div>
</template>

<script>
import { mixin as ClickAway } from 'vue-clickaway2'

export default {
  mixins: [ClickAway],

  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: 'inherit'
    },
    minWidth: {
      type: String,
      default: '0'
    },
    maxWidth: {
      type: String,
      default: '300px'
    },
    menuClass: {
      type: String,
      default: ''
    },
    menuStyle: {
      type: Object,
      default: () => {}
    },
    position: {
      type: String,
      default: 'left'
    },
    bodyClass: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      isOpen: false
    }
  },

  computed: {
    menuStyles () {
      return {
        minWidth: this.minWidth,
        width: this.width,
        maxWidth: this.maxWidth,
        ...this.menuStyle
      }
    },
    menuClasses () {
      return [
        this.menuClass
          ? this.menuClass
          : 'bg-white border border-grey-80 rounded shadow z-30',
        this.isOpen
          ? 'block'
          : 'hidden',
        this.position === 'right'
          ? 'pin-r float-right'
          : 'pin-l float-left'
      ]
    }
  },

  methods: {
    toggle () {
      this.isOpen = !this.isOpen

      this.$nextTick(() => {
        this.$emit(this.isOpen ? 'open' : 'close')
      })
    },

    close () {
      if (this.isOpen) {
        this.isOpen = false
      }
    }
  }
}
</script>
